import { graphql, useStaticQuery } from "gatsby";

const Data = () => {


  const strapiGlobal = useStaticQuery(graphql`
    query MyQuery {
        allStrapiBlog {
        nodes {
          heading
          description
          slug
          publishedAt
          image {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          blog_author {
            name
          }
        }
      }
      strapiHomePage {
        heroSection {
          heading
          subHeading
          heighLight {
            name
            link
          }
          heroImage {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, height: 650)
              }
            }
          }
        }

        workSection {
          heading
          upperHeading
          highlight {
            name
          }
          card {
            title
            color
            bgColor
            description
          }
        }

        serviceSection {
          heading
          upperTitle
          serviceCard {
            color
            description
            title
          }
          highlight {
            name
          }
        }

        packagesSection {
          bgColor
          buttonLink
          buttonText
          description
          rate
          star
          textColor
          title
          icon {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
        }

        happyFaces {
          heading
          happyFacesImages {
            Image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 200, placeholder: BLURRED)
                }
              }
            }
          }
        }
        customerView {
          Heading
          customerViewCard {
            quoteColor
            reviewText
            reviewerName
          }
        }
        seo {
          title
          description
        }
      }

      strapiLayout {
        navbar {
          navbarItem
          navbarLink
        }
        brandLogo {
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: BLURRED)
            }
          }
        }

        footer {
          copyRightText
          bottomDescription {
            footerBarLink
            footerBarText
          }
          payment {
            link
            cardImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(placeholder: BLURRED)
                }
              }
            }
          }
        }
      }
      strapiStepDetail {
        stepFour {
          description
          title
        }
        stepOne {
          description
          title
        }
        stepThree {
          description
          title
        }
        stepTwo {
          description
          title
        }
      }
      strapiViewPage {
        viewPageSeo {
          title
          description
        }
        viewHeroSection {
          heading
          description
          heroImage {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, height: 650)
              }
            }
          }
        }
        brandImages {
          brandLogo {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
        }
      }
      strapiLikePage {
        likePageSeo {
          title
          description
        }
        likeHeroSection {
          heading
          description
          heroImage {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, height: 650)
              }
            }
          }
        }
        brandImages {
          brandLogo {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
        }
      }
      strapiFollowersPage {
        followersPageSeo {
          title
          description
        }
        followersHeroSection {
          heading
          description
          heroImage {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, height: 650)
              }
            }
          }
        }
        brandImages {
          brandLogo {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
        }
      }
      strapiTermsOfService {
        heading
        seo {
          title
          description
        }
        content {
          data {
            content
          }
        }
      }
    }
  `);

  return strapiGlobal;
};

export default Data;
